import { render } from "./ScoresPage.vue?vue&type=template&id=16270987"
import script from "./ScoresPage.vue?vue&type=script&lang=js"
export * from "./ScoresPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__